/**
 * @description component switch theme
 */
import classNames from 'classnames';
import { FC, useEffect } from 'react';

import { THEME_ENUM } from '@/constants';
import { useTheme } from '@/features/global/hooks';
import { useGa } from '@/hooks/useGa';
import { useSwitchTheme } from '@/hooks/useTheme';
import { GaCategory } from '@/utils/analytics';

import IconThemeMoon from './assets/icon-nav-dark.svg?react';
import IconThemeSun from './assets/icon-nav-light.svg?react';
import './index.less';

const SwitchTheme: FC = function () {
  const { dataTheme } = useTheme();
  const gaEvent = useGa();
  const onThemeToggle = useSwitchTheme();
  useEffect(() => {
    if (dataTheme) {
      document.documentElement.setAttribute('data-theme', dataTheme);
    }

    console.record('other', 'Theme init', dataTheme);
  }, [dataTheme]);
  return (
    <div
      className={classNames('switch_theme')}
      onClick={(e) => {
        onThemeToggle();
        e.preventDefault();
        e.stopPropagation();
        gaEvent({
          category: GaCategory.HEADER,
          action: 'Others-Click on Mode',
          label: dataTheme === THEME_ENUM.DARK ? THEME_ENUM.LIGHT : THEME_ENUM.DARK,
        });
      }}>
      <span className={classNames('switch_theme-icon', dataTheme)}>
        {dataTheme === THEME_ENUM.DARK ? <IconThemeMoon /> : <IconThemeSun />}
      </span>
    </div>
  );
};

export default SwitchTheme;
